module.exports = __webpack_public_path__ + "img/mundial-2-tm.3ab7e2cb.png";